<template>
    <div class="wrap">
        <template v-if="!isPhone">
            <!-- top -->
            <Top/>
            <!-- logo -->
            <div class="container logo_wrap">
                <router-link class="logo" to="/"><img src="@/assets/images/toplogo.jpg" alt=""/></router-link>
            </div>
            <!-- nav -->
            <div class="nav_wrap">
                <div class="container">
                    <Navigation/>
                </div>
            </div>
            <!-- banner -->
            <template v-if="config.banner && config.banner.length > 0">
                <DetailBanner/>
            </template>
            <!-- breadcrumb -->
            <div class="container">
                <div class="breadcrumb">{{$t('home')}} &gt; {{menuName}}</div>
            </div>
        </template>
        <template v-else>
            <NavigationMobile/>
            <img v-if="banner" :src="banner" alt="" class="banner_mobile">
        </template>
        <!-- main -->
        <div class="main">
            <div class="container">
                <DetailMenu/>
                <router-view/>
            </div>
        </div>
        <!-- bottom -->
        <Footer/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Top from '../components/top.vue';
import Navigation from '../components/navigation.vue';
import DetailBanner from '../components/detailBanner.vue';
import Footer from '../components/footer.vue';
import DetailMenu from '../components/detailMenu.vue';
import NavigationMobile from '../components/navigationMobile.vue';
export default {
    name: "container",
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['config', 'menuName', 'isPhone', 'banner']),
    },
    components: {
        Top,
        Navigation,
        DetailBanner,
        Footer,
        DetailMenu,
        NavigationMobile
    },
    mounted() {
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.wrap{
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    min-height: 100%;
}
.logo_wrap{
    display: flex;
}
.nav_wrap{
    background: #15428b;
    position: relative;
    height: 40px;
    z-index: 2;
}
.breadcrumb{
    font-size: 12px;
    height: 30px;
    line-height: 30px;
}
.banner_mobile{
    width: 100%;
}
.main{
    background: #e9edf0;
    padding: 70px 0;
    flex: 1;
    .container{
        display: flex;
        align-items: flex-start;
    }
    @media only screen and (max-width: 1024px) {
        background: #fff;
        padding: .3rem;
    }
}
</style>